export default __webpack_public_path__ + "static/media/city2.ea9dae4a.webp";